var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 34,
    viewBox: "0 0 51 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 319
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card-Brands"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Container",
    d: "M46.2188 0.53125H4.78125C2.43404 0.53125 0.53125 2.43404 0.53125 4.78125V29.2188C0.53125 31.566 2.43404 33.4688 4.78125 33.4688H46.2188C48.566 33.4688 50.4688 31.566 50.4688 29.2188V4.78125C50.4688 2.43404 48.566 0.53125 46.2188 0.53125Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M5.92393 12.5682C4.81226 11.9585 3.54352 11.4681 2.125 11.1278L2.1845 10.8627H8.00058C8.78892 10.8904 9.42861 11.1276 9.63676 11.9653L10.9008 17.9915L11.288 19.8065L14.8282 10.8627H18.6507L12.9686 23.9647H9.14593L5.92393 12.5682ZM21.4624 23.9787H17.8475L20.1086 10.8627H23.7233L21.4624 23.9787ZM34.5669 11.1834L34.0753 14.0156L33.7483 13.8763C33.0942 13.6111 32.2308 13.3461 31.0556 13.3741C29.6283 13.3741 28.9882 13.9459 28.9734 14.5041C28.9734 15.1181 29.7477 15.5228 31.0121 16.1229C33.0948 17.0578 34.0609 18.2018 34.0464 19.6949C34.0172 22.4159 31.5478 24.1741 27.7547 24.1741C26.133 24.16 24.5709 23.8385 23.7231 23.4761L24.2289 20.5318L24.705 20.7414C25.8802 21.2303 26.6535 21.4391 28.0967 21.4391C29.1375 21.4391 30.2534 21.0341 30.2676 20.1554C30.2676 19.5833 29.7922 19.1643 28.3936 18.5225C27.0253 17.8943 25.1958 16.848 25.2254 14.9642C25.2409 12.4109 27.7547 10.625 31.3246 10.625C32.723 10.625 33.8539 10.918 34.5669 11.1834ZM39.3715 19.3322H42.3762C42.2275 18.6764 41.543 15.5369 41.543 15.5369L41.2903 14.4067C41.1118 14.895 40.7997 15.6904 40.8147 15.6624C40.8147 15.6624 39.6692 18.5787 39.3715 19.3322ZM43.8337 10.8627L46.75 23.9785H43.4029C43.4029 23.9785 43.0754 22.4715 42.9716 22.011H38.3303C38.1961 22.3597 37.5716 23.9785 37.5716 23.9785H33.7786L39.1481 11.951C39.5201 11.0998 40.1752 10.8627 41.0375 10.8627H43.8337Z",
    fill: "#1434CB"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.c01592d4225733de22efb1cfd2c3d956.svg";
export { ForwardRef as ReactComponent };